import http from '../http'

interface IQueryParams {
  orderNo: string
  outTradeNo: string
}

interface IOfficialOrder {
  country: string;
  paymentMethodId: number;
  skuId: number;
  uid: number;
}

export default {
  // 创建支付订单
  createOrder: (data: any) => http.post('/web/payment/agent/order', data),
  // 查询订单支付结果
  queryOrder: ({ orderNo, outTradeNo }: IQueryParams) => http.get('/web/payment/order/status', { orderNo, outTradeNo }  ),

  /**
   * 官网充值相关(不需要登录)
   */
  // 获取充值渠道
  getWebPaymentMethods: ({ country, uid }: { country: string; uid: number }) =>
    http.get(`/web/payment/methods?country=${country}&uid=${uid}`),
  // 创建订单
  createWebPaymentOrder: (data: IOfficialOrder) =>
    http.post('/web/payment/order', data),
  // 获取用户信息
  getUserInfo: ({ duid, country }: { duid: string; country: string }) =>
    http.get(`/account/${duid}?country=${country}`),
}
